import { createRootRoute, Outlet } from '@tanstack/react-router';
import { Toaster } from 'sonner';

export const Route = createRootRoute({
  component: () => (
    <div className="min-h-dvh bg-bg-base text-fg-primary">
      <Outlet />
      <Toaster richColors position="top-center" />
    </div>
  ),
});
